import { useCallback, useRef } from 'react';

import { useHistory } from 'src/lib/hooks/useHistory';
import { ROUTES } from 'src/routes';
// @ts-expect-error - no TypeScript definitions yet
import { useNotificationActions } from 'src/store/notification';

export const useHandlers = () => {
  const history = useHistory();
  const notificationActions = useNotificationActions();
  // Several calls can fail together, e.g. a refetch and a mutation. The page is left once.
  const accessLostRef = useRef(false);

  const handleAccessLost = useCallback(() => {
    if (accessLostRef.current) {
      return;
    }
    accessLostRef.current = true;
    notificationActions.displayWarning('This project is no longer shared with you.');
    history.replace(ROUTES.ROOT);
  }, [history, notificationActions]);

  return { handleAccessLost };
};
